import { APIClient } from '@frontend/api-utils';

export class LockerEnumClient extends APIClient {
    public static readonly endpoint = '/locker-api/v1';

    public static async fetchLockerStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/locker-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchLockerTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/locker-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchLockerActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/locker-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
